import React from 'react'
import Layout from "../Layout";
import List from '../Components/Stock/List';

function Stock() {
  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Stock View</h1>
          </div>
          <List/>
        </section>
      </div>
    </Layout>
  )
}

export default Stock